import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import Body1 from './Typography/Body/Body1';
import Headline4 from './Typography/Heading/Headline4';
import Headline6 from './Typography/Heading/Headline6';
import Button from './Button';
import grey from './Palettes/grey';

const ExpiredContainer = styled.div`
  border-bottom: 2px solid ${grey[650]};
  border-top: 2px solid ${grey[650]};
  position: relative;
  top: -1px;
  padding: 32px 0;
  text-align: center;
`;

const MoreJobsButton = styled(Button)`
  && {
  margin: 0px auto 12px;
  padding: 0 12px;
  display: inline-block;
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.main};
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;

const StyledHeadline4 = styled(Headline4)`
  && {
    margin: 0 0 1rem;
  }
`;

const StyledHeadline6 = styled(Headline6)`
  && {
    margin: 0 0 1rem;
  }
`;

const StyledBody1 = styled(Body1)`
  && {
    margin: 16px;
  }
`;

const jobExpiredPropertyTypes = {
  archivedJobsHeader: PropTypes.string.isRequired,
  moreJobsLink: PropTypes.node.isRequired,
  relatedSearchesHeader: PropTypes.string.isRequired,
  relatedSearches: PropTypes.arrayOf(
    PropTypes.node,
  ).isRequired,
};

type JobExpiredProperties = InferProps<typeof jobExpiredPropertyTypes>;

const JobExpired = ({
  archivedJobsHeader,
  moreJobsLink,
  relatedSearchesHeader,
  relatedSearches,
}: JobExpiredProperties) => (
  <ExpiredContainer>
    <StyledHeadline4 tag="h2">
      { archivedJobsHeader }
    </StyledHeadline4>
    <MoreJobsButton variant="text">
      { moreJobsLink }
    </MoreJobsButton>
    <StyledBody1>
      { relatedSearchesHeader }
    </StyledBody1>
    { relatedSearches.map(
      (relatedSearch, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <StyledHeadline6 tag="h3" key={index}>
          { relatedSearch }
        </StyledHeadline6>
      ),
    ) }
  </ExpiredContainer>
);

JobExpired.propTypes = jobExpiredPropertyTypes;

export default JobExpired;
